<template lang="pug">
#modelsys.comAll(v-dragDiv,v-show="!actionData.isMini")
  .title.moveDragDiv
    span {{actionData.cnName}}
    i.el-icon-minus.minibtn(title='最小化' @click='miniCom')
    i.el-icon-close(title='关闭' @click='closeAdd')
  .content
    el-tree.navTree(ref='tree',highlight-current,:props='defaultProps',:data="sysData", v-slot="{ node, data }")
      .labelst(@click.stop="handleClick(data)" :title="data.label")
        img(:src="aimImage",class="select",alt="选中" v-if="checkData.mgNodeId === data.mgNodeId && data.elementId")
        .name {{data.label}}
        img(:src="targetIamge" alt="定位" v-if="checkData.mgNodeId === data.mgNodeId && data.elementId")
</template>

<script>
import mongeApiMlib from "@/CommonDP/mongeView/mongeApiMlib";
export default {
  props: {
    actionData: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data () {
    return {
      aimImage: require("../images/空间系统选中.png"),
      targetIamge: require("../images/定位.png"),
      sysData: [],
      checkData: "",
      defaultProps: {
        children: "children",
        label: "label"
      }
    };
  },
  mounted () {
    this.init();
  },
  methods: {
    async init() {
      this.sysData = await mongeApiMlib.loadSysData();
    },
    miniCom() {
      this.$emit("closeCom", 'modelSystem', true);
    },
    closeAdd() {
      this.$emit("closeCom", 'modelSystem', false);
    },
    handleClick(data) {
      if (data.mgNodeId != this.checkData.mgNodeId) {
        this.checkData = data;
        mongeApiMlib.selectPick(data);
      } else {
        this.checkData = "";
        mongeApiMlib.cancelSelectPick();
      }
    }
  }
};
</script>

<style lang="scss" scoped src="@/CommonDP/mongeView/common/common.scss" ></style>
<style lang="scss" scoped>
#modelsys{
  position: fixed;
  top: 65px;
  left: 151px;
  width: 300px;
  height: calc(100% - 190px);
  max-height: 770px;
  .content{
    width: 100%;
    height: calc(100% - 40px);
    padding: 10px 10px 10px 15px;
    overflow: hidden;
    overflow-y: auto;
    .labelst{
      width: 100%;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      position: relative;
      .name{
        margin-left: 10px;
      }
      .select{
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
      }
    }
  }
}
</style>
